import React, {Component} from 'react'
import {withTranslation} from 'react-i18next';

/**
 * Have the title of the CallForApplicationItem displayed on two lines
 *
 * @param {string} value
 * @returns {string}
 */
const formatTitle = (value) => {
	let formattedValue = <span>{value}</span>;
	if (value) {
		const titleParts = value.split(' – ')
		if (titleParts.length > 1) {
			formattedValue = <span>{titleParts[0]} <br/> {titleParts[1]}</span>;
		}
	}
	return formattedValue
}

const formatStars = (pos) => {
	let stars = '';
	let i = 0;

  // Can be set in ApplicationForm Node, defaults to 5 if not set
  let maximumNumberOfItemsInBasket = parseInt(AblCh.maximumNumberOfItemsInBasket);
  let numOfStars = (maximumNumberOfItemsInBasket > 0 ? maximumNumberOfItemsInBasket : 5) - (pos - 1)

	while (i < numOfStars) {
		stars = stars + '♥︎';
		i++;
	}
	return stars;
};


// Decorate the class.
@withTranslation()
export default class BasketSummaryEdit extends Component {

	/**
	 * @param {object} props
	 */
	constructor(props) {
		super(props)
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t} = this.props;
		return (
			<div>
				<div className="basket__summary clearfix">
					<div><h3>{t('basket.applicationfor', {count: this.props.items.length})}</h3></div>

					{this.props.items.map((item, index) => {
						return (
							<div key={index} className="basket__item" style={{'cursor': 'auto'}}>
								<div className="myrating">
									{formatStars(index + 1)}
								</div>
								<div className="basket__item-position">
									Ausschreibung Nr. {item.callForApplicationItem.position}
								</div>
								<div className="title">
									{formatTitle(item.callForApplicationItem.title)}<br />
									{item.callForApplicationItem.realEstateObject.floor}
								</div>
							</div>
						)
					})}
				</div>
			</div>
		)
	}
}
